module.exports = __webpack_public_path__ + "static/media/repoBaseExito.b0a9f889.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/repoBaseExito.png
// module id = 2021
// module chunks = 0